import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b95d0130&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b95d0130&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=b95d0130&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95d0130",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b95d0130')) {
      api.createRecord('b95d0130', component.options)
    } else {
      api.reload('b95d0130', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b95d0130&scoped=true", function () {
      api.rerender('b95d0130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/record/detail/index.vue"
export default component.exports